import React from 'react'
import { useTranslation } from 'react-i18next'
import { ChatMessage } from 'types/Chat'
import { formatMessageTime } from 'utils/formatMessageTime'
import { ChatAttachmentList } from 'components/data/ChatAttachmentList/ChatAttachmentList'
import { ChatMessageParts } from './ChatMessageParts'
import * as Styled from './ChatMessages.styles'

interface ChatMessageItemProps {
  message: ChatMessage
}

const ChatMessageItem: React.FC<ChatMessageItemProps> = React.memo(({ message }) => {
  const { t } = useTranslation()

  return (
    <Styled.MessageContainer $isUser={message.role === 'user'}>
      {message.role === 'user' ? (
        <Styled.MessageBubbleWrapper>
          <ChatAttachmentList attachments={message.attachments} align='right' />
          {message.content && (
            <Styled.MessageBubble>{message.content}</Styled.MessageBubble>
          )}
        </Styled.MessageBubbleWrapper>
      ) : message.isStreaming && !message.content ? (
        <Styled.TypingIndicator aria-label={t('aiChat.typing')} role='status'>
          <span />
          <span />
          <span />
        </Styled.TypingIndicator>
      ) : (
        <ChatMessageParts message={message} />
      )}
      {!message.isStreaming && (
        <Styled.MessageTime
          $isUser={message.role === 'user'}
          dateTime={new Date(message.createdAt).toISOString()}
        >
          {formatMessageTime(message.createdAt)}
        </Styled.MessageTime>
      )}
    </Styled.MessageContainer>
  )
})

export { ChatMessageItem }
